import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyB-ExLenwM4-uUwp4J4GPDFOsVEI_rjQVk",
    authDomain: "polychromeproject.firebaseapp.com",
    databaseURL: "https://polychromeproject.firebaseio.com",
    projectId: "polychromeproject",
    storageBucket: "",
    messagingSenderId: "17934005023",
    appId: "1:17934005023:web:51b380f4db04361c"
};

firebase.initializeApp(firebaseConfig);

export default firebase;